const Heading = ({ title }: { title: string }) => {
  return (
    <div className="bg-white dark:bg-slate-950 w-full text-center relative flex items-center justify-center rounded-md">
      <div className="absolute inset-0 flex items-center w-[90%] mx-auto pt-1">
        <div className="w-full border-b-2 border-dotted border-gray-300"></div>
      </div>
      <h2 className="text-3xl lg:text-4xl bg-white dark:bg-slate-950 px-4 relative z-10">{title}</h2>
    </div>
  );
};

export default Heading;
